module.exports = __webpack_public_path__ + "static/img/5.4767cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/en/5.jpg
// module id = R2+y
// module chunks = 2